import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { getDateFormat } from "../../helpers/Utils";
import useFetch from "../../hooks/useFetch";
import { putAutosys } from "../../redux/Actions/autosys_action ";
import { ButtonSecondary } from "../common";
import { SelectForm } from "../common/Buttons";
// import InputSwitchComponent from "../common/InputSwitchComponent";
import RangePickerComp from "../common/RangePickerComp";
import Spinner from "../common/Spinner";
import SwitchComp from "../common/SwitchComp";
import TextInputModal from "../common/TextInputModal";
import ModalSpecial from "../Layout/Modals/ModalSpecial";
import AutosysApplyAction from "./AutosysApplyAction";
import AutosysSku from "./AutosysSku";
import styled from "styled-components";
import { Checkbox } from "antd";
import { Label, SelectInput } from "../globals";

const AutosysModal = ({ modalFunc, id, shops }) => {
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const creating = id == 0;
  const { loading, value, setValue } = useFetch(
    `/api/v1/autosys/${creating ? "new" : id}`
  );

  if (loading) {
    return (
      <ModalSpecial
        style={{
          width: 500,
        }}
        onClose={() => modalFunc(false)}
      >
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ height: "100%" }}
        >
          <Spinner />
        </div>
      </ModalSpecial>
    );
  }

  const onChange = (e) => {
    const { name, value } = e.target;
    setValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validError = () => {
    let error = {};
    if (value.apply_action == "change_sku") {
      if (!value.parameters?.price) error.price = "Check the price";
      if (!value.parameters?.qty) error.qty = "Check the quantity";
      if (!value.parameters?.sku) error.sku = "Fill in the field";
    }
    setErrors(error);
    return Object.values(error).length > 0;
  };

  const onSave = async () => {
    try {
      setErrors({});
      if (validError()) return;

      // change_sku

      const { success, errors } = await dispatch(putAutosys(value));
      if (success) {
        modalFunc(false);
      } else {
        setErrors(errors);
      }
    } catch (e) {
      console.log("ERROR: " + e);
    }
  };

  const onChangeAutoType = (val) => {
    let custom_value = value?.auto_type || "";
    let val_return = "";

    if (custom_value == "all") {
      val_return = val == "order_created" ? "product_added" : "order_created";
    } else if (val == custom_value) {
      val_return = "";
    } else {
      if (custom_value == "") {
        val_return = val;
      } else if (custom_value !== val) {
        val_return = "all";
      }
    }
    onChange({
      target: {
        value: val_return,
        name: "auto_type",
      },
    });
  };

  return (
    <ModalSpecial
      style={{
        width: 500,
      }}
      text={creating ? "Create rule" : "Edit rule"}
      // onClose={() => modalFunc(false)}

      onClose={() => {
        if (confirm(`Are you sure want to close modal?`)) {
          return modalFunc(false);
        }
      }}
    >
      <div>
        <TextInputModal
          text="Rule title"
          name="rule_title"
          required={true}
          value={value.rule_title}
          onChange={(e) => onChange(e)}
          warning={errors.rule_title}
        />
        <div className="my-2" />
        {/* <InputSwitchComponent
          label={"When"}
          name="auto_type"
          options={[
            {
              label: "Order created",
              value: "order_created",
            },
            {
              label: "Product added",
              value: "product_added",
            },
          ]}
          value={value.auto_type}
          onChange={(e) => onChange(e)}
        /> */}

        <div className={`text-bold my-1 ${errors.auto_type && "text-danger"}`}>
          {"When"} <span className="orange_color">*</span>
        </div>
        {[
          {
            label: "Order created",
            value: "order_created",
          },
          {
            label: "Product added",
            value: "product_added",
          },
        ].map((d) => {
          const active = [d.value, "all"].includes(value.auto_type);
          return (
            <ApplyActionItemStyled
              key={d.value}
              className="mb-2 cursor-pointer"
              active={active}
              onClick={() => onChangeAutoType(d.value)}
            >
              <div className={`pl-3 py-2 text-xs text-font font-semi-bold`}>
                <Checkbox
                  checked={active}
                  onChange={() => onChangeAutoType(d.value)}
                />
                <span
                  className={`pl-2 text-xs text-font font-semi-bold `}
                  style={{
                    color: active ? "#03b0f7" : "#6C6C6C",
                  }}
                >
                  {d.label}
                </span>
                {/* <span className="pl-2">{d.label}</span> */}
              </div>
            </ApplyActionItemStyled>
          );
        })}

        <div className="my-2" />

        <SelectInput
          required={true}
          mode={"multiple"}
          label="Shops"
          options={shops}
          value={value.order_shop_ids}
          onChange={(value) => {
            onChange({ target: { name: "order_shop_ids", value } })
          }}
          error={errors.order_shop_ids}
        />
        <div className="my-2" />
        <AutosysSku
          warning={errors.autosys_products_attributes}
          products={value.autosys_products}
          setValue={setValue}
        />
        {/* <div className="d-flex flex-column">
          <SwitchComp
            placeholder="Products without services"
            checked={value.products_without_services}
            onChange={() =>
              onChange({ target: { name: "products_without_services", value: !value.products_without_services } })
            }
          />
        </div> */}

        <div className="my-2" />
        <Label required={true}>Apply action</Label>
        <AutosysApplyAction
          shop_ids={value.shop_ids}
          apply_action={value.apply_action}
          parameters={value.parameters}
          setValue={setValue}
          errors={errors}
          order_shop_id={value.order_shop_ids || [1]}
        />
        <div className="my-3" />
        <div>
          <RangePickerComp
            renderExtraFooter={() => (
              <div className="d-flex align-items-center justify-content-center">
                {!!value.period &&
                  !!value.period.length &&
                  !!value.period[0] && (
                    <div
                      className="text-primary py-2 cursor-pointer"
                      onClick={() => {
                        onChange({
                          target: {
                            name: "period",
                            value: [value.period[0], ""],
                          },
                        });
                        // document
                        //   .querySelector(
                        //     ".ant-picker-dropdown-range.ant-picker-dropdown-placement-topRight"
                        //   )
                        //   .classList.add("ant-picker-dropdown-hidden");
                      }}
                    >
                      Do not set end date
                    </div>
                  )}
              </div>
            )}
            style={{
              width: "100%",
            }}
            label="Period"
            required={true}
            placeholder={["Start date", "End date"]}
            disabledDate={() => { }}
            value={
              value.period
                ? [
                  getDateFormat(value.period[0]),
                  getDateFormat(value.period[1]),
                ]
                : ["", ""]
            }
            onCalendarChange={(_, value) => {
              onChange({
                target: {
                  name: "period",
                  value,
                },
              });
            }}
            warning={errors.period}
          />
        </div>
        <div className="my-3" />
        <div className="d-flex flex-column">
          <SwitchComp
            placeholder="Status"
            checked={value.status}
            onChange={() =>
              onChange({ target: { name: "status", value: !value.status } })
            }
          />
        </div>
        <div className="my-3" />
        <ButtonSecondary onClick={() => onSave()}>
          {creating ? "Create" : "Update rule"}
        </ButtonSecondary>
      </div>
    </ModalSpecial>
  );
};

export default AutosysModal;

const ApplyActionItemStyled = styled.div`
  background: ${(props) => (props.active ? "#edf9fe" : "#fcfcfc")};
  border: 1px solid ${(props) => (props.active ? "#03B0F7" : "#d9d9d9")};
  border-radius: 4px;
`;
